import { storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';

export const uploadLabFile = (file, resultId, onProgress) => {
  return new Promise((resolve, reject) => {
    const ext = file.name.split('.').pop().toLowerCase();
    const path = `labFiles/${resultId}/original.${ext}`;
    const storageRef = ref(storage, path);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const pct = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
        onProgress && onProgress(pct);
      },
      (error) => reject(error),
      async () => {
        const url = await getDownloadURL(uploadTask.snapshot.ref);
        resolve({ url, path, ext });
      }
    );
  });
};

export const uploadLabReport = async (blob, resultId) => {
  const path = `labReports/${resultId}/report.pdf`;
  const storageRef = ref(storage, path);
  await uploadBytesResumable(storageRef, blob);
  return getDownloadURL(storageRef);
};

export const deleteLabFile = async (path) => {
  const storageRef = ref(storage, path);
  await deleteObject(storageRef);
};
